/* Elif Transfer — Canli Mockup Studyosu
 * snippets/elif-mockup-studyo.liquid ile calisir.
 * Sayfada BIRDEN FAZLA studyo olabilir (ana sayfa + tekstil landing); her biri ayri baglanir.
 * Musterinin yukledigi logo FileReader ile TARAYICIDA okunur, sunucuya gitmez.
 */
(function () {
  'use strict';

  function init(studio) {
    if (studio.getAttribute('data-ems-init')) return;
    studio.setAttribute('data-ems-init', '1');

    var logoWrap = studio.querySelector('[data-ems-logo]');
    var logoImg = studio.querySelector('[data-ems-logoimg]');
    var ph = studio.querySelector('[data-ems-ph]');
    var posRow = studio.querySelector('[data-ems-posrow]');
    var fileIn = studio.querySelector('[data-ems-file]');
    var upLabel = studio.querySelector('[data-ems-uplabel]');
    var msgEl = studio.querySelector('[data-ems-msg]');
    var sizeIn = studio.querySelector('[data-ems-size]');

    /* Gogus konumlari editorden ayarlanir: merkeze gore simetrik sapma + dikey konum */
    var OFF = parseFloat(studio.getAttribute('data-off'));
    var CTOP = parseFloat(studio.getAttribute('data-ctop'));
    var MTOP = parseFloat(studio.getAttribute('data-mtop'));
    if (isNaN(OFF)) OFF = 10;
    if (isNaN(CTOP)) CTOP = 40;
    if (isNaN(MTOP)) MTOP = 44;

    var POS = {
      left:   { x: (50 - OFF) + '%', y: CTOP + '%' },
      center: { x: '50%',            y: MTOP + '%' },
      right:  { x: (50 + OFF) + '%', y: CTOP + '%' }
    };

    function msg(t, bad) {
      if (!msgEl) return;
      if (!t) { msgEl.hidden = true; return; }
      msgEl.textContent = t;
      msgEl.hidden = false;
      msgEl.className = 'ems__msg' + (bad ? ' is-err' : '');
    }

    function reset() {
      if (logoImg) logoImg.removeAttribute('src');
      if (logoWrap) logoWrap.hidden = true;
      if (ph) ph.hidden = false;
      if (posRow) posRow.hidden = true;
      if (upLabel) upLabel.textContent = upLabel.getAttribute('data-orig') || 'Logo yükle';
      if (fileIn) fileIn.value = '';
      msg('');
    }

    studio.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      var t = e.target.closest('[data-ems-type]');
      if (t) {
        var idx = t.getAttribute('data-ems-type');
        studio.querySelectorAll('[data-ems-type]').forEach(function (b) { b.classList.toggle('is-on', b === t); });
        studio.querySelectorAll('[data-ems-garment]').forEach(function (g) {
          g.classList.toggle('is-on', g.getAttribute('data-ems-garment') === idx);
        });
        return;
      }

      var c = e.target.closest('[data-ems-color]');
      if (c) {
        studio.style.setProperty('--g', c.getAttribute('data-ems-color'));
        studio.querySelectorAll('[data-ems-color]').forEach(function (b) { b.classList.toggle('is-on', b === c); });
        var n = studio.querySelector('[data-ems-cname]');
        if (n) n.textContent = c.getAttribute('data-ems-name') || '';
        return;
      }

      var p = e.target.closest('[data-ems-pos]');
      if (p) {
        var k = POS[p.getAttribute('data-ems-pos')] || POS.center;
        studio.style.setProperty('--lx', k.x);
        studio.style.setProperty('--ly', k.y);
        studio.querySelectorAll('[data-ems-pos]').forEach(function (b) { b.classList.toggle('is-on', b === p); });
        return;
      }

      if (e.target.closest('[data-ems-clear]')) { reset(); }
    });

    if (sizeIn) {
      sizeIn.addEventListener('input', function () { studio.style.setProperty('--lw', sizeIn.value + '%'); });
    }

    if (fileIn) {
      if (upLabel) upLabel.setAttribute('data-orig', upLabel.textContent.trim());
      fileIn.addEventListener('change', function () {
        var f = fileIn.files && fileIn.files[0];
        if (!f) return;
        if (f.type.indexOf('image/') !== 0) { msg('Lütfen bir görsel dosyası seç (PNG, JPG, SVG, WEBP).', true); fileIn.value = ''; return; }
        if (f.size > 5 * 1024 * 1024) { msg('Dosya 5 MB’tan küçük olmalı.', true); fileIn.value = ''; return; }
        var r = new FileReader();
        r.onload = function (ev) {
          logoImg.src = ev.target.result;
          logoWrap.hidden = false;
          if (ph) ph.hidden = true;
          if (posRow) posRow.hidden = false;
          if (upLabel) upLabel.textContent = 'Değiştir';
          msg('');
        };
        r.onerror = function () { msg('Dosya okunamadı, tekrar dener misin?', true); };
        r.readAsDataURL(f);
      });
    }
  }

  function boot() {
    var all = document.querySelectorAll('[data-ems]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
